import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "confirmation-dialog-submit-promo",
  templateUrl: "./confirmation-dialog-submit-promo.html",
  styleUrls: ["./confirmation-dialog-submit-promo.scss"],
})
export class ConfirmationDialogSubmitPromo {
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogSubmitPromo>) {}

  confirmNavigation(flag) {
    this.dialogRef.close({ event: flag });
  }
}
